import { render } from "./AprobariManager.vue?vue&type=template&id=5047ecb2&scoped=true&ts=true"
import script from "./AprobariManager.vue?vue&type=script&lang=ts"
export * from "./AprobariManager.vue?vue&type=script&lang=ts"

import "./AprobariManager.vue?vue&type=style&index=0&id=5047ecb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5047ecb2"]])

export default __exports__